module.exports = __webpack_public_path__ + "img/image_part_008.25c32b57.jpg";